/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { HiOutlineBars3 } from "react-icons/hi2";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import HomeIcon from "@mui/icons-material/Home";
import LocalFloristIcon from "@mui/icons-material/LocalFlorist";
import Logo from "../../Assets/Logo.png";

const Navbar = () => {
  const [openMenu, setOpenMenu] = useState(false);
  
  const menuOptions = [
    {
      text: "Principal",
      icon: <HomeIcon />,
      path: "/",
    },
    {
      text: "Hortaliças no Atacado",
      icon: <LocalFloristIcon />,
      path: "/hortalicas",
    },
  ];

  return (
    <nav>
      <div className="nav-logo-container">
        <Link to="/">
          <img 
            src={Logo} 
            alt="Verde Musgo Natural - Logo da empresa de produtos agroecológicos" 
            style={{ marginTop: "5px" }} 
          />
        </Link>
      </div>
      <div className="navbar-links-container">
        <Link to="/">Principal</Link>
        <Link to="/hortalicas">Hortaliças no Atacado</Link>
        <button 
          className="primary-button" 
          onClick={() => window.open("https://loja.verdemusgonatural.com.br", "_blank")}
        >
          Comprar
        </button>
      </div>
      <div className="navbar-menu-container">
        <HiOutlineBars3 onClick={() => setOpenMenu(true)} />
      </div>
      <Drawer open={openMenu} onClose={() => setOpenMenu(false)} anchor="right">
        <Box
          sx={{ width: 250 }}
          role="presentation"
          onClick={() => setOpenMenu(false)}
          onKeyDown={() => setOpenMenu(false)}
        >
          <List>
            {menuOptions.map((item) => (
              <ListItem key={item.text} disablePadding>
                <ListItemButton component={Link} to={item.path}>
                  <ListItemIcon>{item.icon}</ListItemIcon>
                  <ListItemText primary={item.text} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <Divider />
        </Box>
      </Drawer>
    </nav>
  );
};

export default Navbar;